import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import UserDashboard from "./pages/UserDashboard";
import MaintenanceDashboard from "./pages/MaintenanceDashboard";
import TeknisiDashboard from "./pages/TeknisiDashboard";

import { AuthProvider } from "./contexts/AuthContext";
import { AdminProvider } from "./contexts/AdminContext";
import { UserProvider } from "./contexts/UserContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PopupHost from "./components/common/PopupHost";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        {/* Host popup global (notif OK + konfirmasi Ya/Tidak) — dipasang sekali */}
        <PopupHost />
        <Routes>
          {/* Default */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Admin */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute role="admin">
                <AdminProvider>
                  <AdminDashboard />
                </AdminProvider>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-dashboard/:tab"
            element={
              <ProtectedRoute role="admin">
                <AdminProvider>
                  <AdminDashboard />
                </AdminProvider>
              </ProtectedRoute>
            }
          />

          {/* User */}
          <Route
            path="/user-dashboard/*"
            element={
              <ProtectedRoute role="user">
                <UserProvider>
                  <UserDashboard />
                </UserProvider>
              </ProtectedRoute>
            }
          />

          {/* Maintenance */}
          <Route
            path="/maintenance-dashboard"
            element={
              <ProtectedRoute role="maintenance">
                <MaintenanceDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/maintenance-dashboard/:tab"
            element={
              <ProtectedRoute role="maintenance">
                <MaintenanceDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/maintenance-dashboard/:tab/:subtab"
            element={
              <ProtectedRoute role="maintenance">
                <MaintenanceDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/maintenance-dashboard/:tab/:subtab/:tool_id"
            element={
              <ProtectedRoute role="maintenance">
                <MaintenanceDashboard />
              </ProtectedRoute>
            }
          />

          {/* Teknisi */}
          <Route
            path="/teknisi-dashboard"
            element={
              <ProtectedRoute role="teknisi">
                <TeknisiDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/teknisi-dashboard/:tab"
            element={
              <ProtectedRoute role="teknisi">
                <TeknisiDashboard />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
